export default __webpack_public_path__ + "static/media/raspberrypi.79bdbe2c.png";